import { RatingDisplay } from "./rating-display.js";
import { RatingDisplayStyles, RatingDisplayTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * @public
 * @remarks
 * HTML Element: <fabric-rating-display>
 */
export const definition = RatingDisplay.compose({
    name: `${DesignSystem.prefix}-rating-display`,
    template: RatingDisplayTemplate,
    styles: RatingDisplayStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=rating-display.definition.js.map